/* Polsk katalog for locale-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'sup.archiveBody': 'Czy przenieść {name} do archiwum? Dostawca zostanie ukryty na listach aktywnych dostawców, ale faktury, płatności i historia zostaną zachowane. Możesz później ponownie otworzyć dostawcę.',
  'cust.title': 'Klienci',
  'cust.subtitle': 'Wszyscy Twoi klienci w jednym miejscu',
  'cust.searchPh': 'Szukaj klienta lub kwoty',
  'cust.titleHelp': 'Twój rejestr klientów — wszyscy klienci z danymi kontaktowymi, należnościami i łączną sprzedażą. Dotknij klienta, aby zobaczyć działania i faktury.',
  'cust.searchHelp': 'Szukaj klientów po nazwie, e-mailu, łącznej sprzedaży lub kwocie należności.',
  'cust.uploadHelp': 'Importuj klientów z pliku.',
  'cust.downloadHelp': 'Pobierz listę klientów jako CSV lub Excel.',
  'cust.addHelp': 'Dodaj nowego klienta z danymi kontaktowymi i statusem obsługi.',
  'cust.filterHelp': 'Filtruj klientów według statusu (aktywny, potencjalny, oferta wysłana, wstrzymany), według tego, czy mają należności, oraz czy pokazywać zarchiwizowanych.',
  'cust.listHelpTitle': 'Lista klientów',
  'cust.listHelp': 'Każdy wiersz to jeden klient z numerem klienta, nr org., e-mailem, telefonem, należnością i łączną sprzedażą. Dotknij wiersza, aby otworzyć klienta.',
  'cust.filterOther': 'Inne',
  'cust.filterWithOutstanding': 'Tylko z należnościami',
  'cust.filterShowArchive': 'Pokaż archiwum',
  'cust.archived': 'Zarchiwizowany',
  'cust.followUpInline': 'Kontakt {date}',
  'cust.col.customer': 'Klient',
  'cust.col.number': 'Nr klienta',
  'cust.col.org': 'Nr org.',
  'cust.col.email': 'E-mail',
  'cust.col.phone': 'Telefon',
  'cust.col.outstanding': 'Należność',
  'cust.col.totalSales': 'Łączna sprzedaż',
  'cust.outstandingInline': 'Należność {amount}',
  'cust.balance.customerOwes': 'Klient jest Ci winien {amount}',
  'cust.balance.youOwe': 'Jesteś winien klientowi {amount}',
  'cust.balance.settled': 'Rozliczone',
  'cust.followUp': 'Działania',
  'cust.followUpHelp': 'Status, data następnego kontaktu, notatki i ostatnie aktywności klienta. Użyj przycisku czatu, aby zapisać rozmowę i przygotować ofertę.',
  'cust.dialogTitle': 'Rozmowa z klientem',
  'cust.dialogHelp': 'Otwórz rozmowę z klientem — zapisuj wiadomości i buduj podstawę oferty, którą możesz zamienić w ofertę.',
  'cust.openChat': 'Otwórz czat',
  'cust.startChat': 'Rozpocznij czat',
  'cust.nextFollowUp': 'Następny kontakt',
  'cust.noFollowUpDate': 'Nie ustawiono daty',
  'cust.status': 'Status',
  'cust.salesTitle': 'Sprzedaż do klienta',
  'cust.salesHelp': 'Wszystkie faktury i faktury korygujące klienta. Filtruj: wszystkie, nieopłacone lub opłacone — i otwórz fakturę bezpośrednio przyciskiem „Otwórz”.',
  'cust.salesAll': 'Wszystkie',
  'cust.salesUnpaid': 'Nieopłacone',
  'cust.salesPaid': 'Opłacone',
  'cust.salesTotal': 'Razem',
  'cust.noSalesMatch': 'Żadna sprzedaż nie pasuje do filtra.',
  'cust.creditNote': 'Faktura korygująca',
  'cust.invoice': 'Faktura',
  'cust.dueOn': 'Termin płatności {date}',
  'cust.open': 'Otwórz',
  'cust.pageRange': '{from}-{to} z {total}',
  'cust.prev': 'Poprzednia',
  'cust.next': 'Następna',
  'cust.act.newInvoice': 'Nowa faktura',
  'cust.act.newInvoiceHelp': 'Rozpocznij nową fakturę z już wybranym tym klientem.',
  'cust.act.edit': 'Edytuj',
  'cust.act.editHelp': 'Zmień dane kontaktowe, status i działania klienta.',
  'cust.act.merge': 'Scal',
  'cust.act.mergeHelp': 'Scal dwóch klientów zarejestrowanych podwójnie — sprzedaż i należności zostaną połączone na jednym kliencie.',
  'cust.act.archive': 'Przenieś do archiwum',
  'cust.act.archiveHelp': 'Ukryj klienta na aktywnych listach. Faktury, płatności i historia zostaną zachowane.',
  'cust.act.menu': 'Działanie',
  'cust.archiveTitle': 'Przenieść do archiwum?',
  'cust.archiveBody': 'Czy przenieść {name} do archiwum? Klient zostanie ukryty na listach aktywnych klientów, ale faktury, płatności i historia zostaną zachowane.',
  'cust.archiveStillUsed': 'Klient jest nadal używany w innych miejscach',
  'cust.archiveGroup': 'grupa klientów: {n}',
  'cust.archiveGroups': 'grupy klientów: {n}',
  'cust.archiveSubscription': 'subskrypcja: {n}',
  'cust.archiveSubscriptions': 'subskrypcje: {n}',
  'cust.archiveAnd': ' i ',
  'cust.merge.title': 'Scal klientów',
  'cust.merge.keep': 'Zostaje',
  'cust.merge.remove': 'Zostanie scalony i usunięty',
  'cust.merge.swap': 'Zamień, który klient zostaje',
  'cust.merge.after': 'Po scaleniu',
  'cust.merge.name': 'Nazwa klienta',
  'cust.merge.totalSales': 'Łączna sprzedaż',
  'cust.merge.notConnected': 'Scalanie nie jest jeszcze połączone z serwerem.',
  'cust.merge.done': 'Klienci zostali scaleni',
  'cust.merge.failed': 'Nie udało się scalić klientów.',
  'cust.form.name': 'Nazwa klienta',
  'cust.form.namePh': 'Np. Przykład AS',
  'cust.form.orgOptional': 'Numer org. (opcjonalnie)',
  'cust.form.org': 'Numer org.',
  'cust.form.address': 'Adres',
  'cust.form.addressPh': 'Ulica i numer',
  'cust.form.zip': 'Kod pocztowy',
  'cust.form.city': 'Miejscowość',
  'cust.form.cityPh': 'Miejscowość',
  'cust.form.crm': 'Status klienta',
  'cust.form.nextLabel': 'Następny: {date}',
  'cust.form.noFollowUp': 'Brak działań',
  'cust.form.dupTitle': 'Te dane ma już inny klient',
  'cust.form.dupName': '{names} ma tę samą nazwę.',
  'cust.form.dupOrg': '{names} ma ten sam numer organizacyjny.',
  'cust.form.dupEmail': '{names} ma ten sam adres e-mail.',
  'cust.form.dupPhone': '{names} ma ten sam numer telefonu.',
  'cust.form.dupUnnamed': 'Klient bez nazwy',
  'cust.form.dupBody': 'Klient zostanie zapisany normalnie. Jeśli to ten sam klient, możesz scalić oba wpisy z karty klienta na liście.',
  'cust.form.contacts': 'Osoby kontaktowe',
  'cust.form.contactsSub': 'Można je wybrać jako odbiorcę przy wysyłaniu faktury, oferty lub potwierdzenia.',
  'cust.form.addContact': 'Dodaj osobę kontaktową',
  'cust.form.editContact': 'Edytuj osobę kontaktową',
  'cust.form.contactFallback': 'Osoba kontaktowa {n}',
  'cust.form.removeContact': 'Usuń osobę kontaktową',
  'cust.form.contactTitle': 'Osoba kontaktowa',
  'cust.form.newTitle': 'Nowy klient',
  'cust.form.editTitle': 'Edytuj klienta',
  'cust.form.saveContact': 'Zapisz',
  'cust.form.contactName': 'Imię i nazwisko',
  'cust.form.contactNamePh': 'Np. Kari Nordmann',
  'cust.form.contactRole': 'Rola',
  'cust.form.contactRolePh': 'Np. Księgowość',
  'cust.form.defaultRef': 'Stała referencja faktury',
  'cust.form.defaultRefPh': 'Np. numer projektu, zamówienie zakupu lub dział',
  'cust.form.creditLimit': 'Limit kredytowy',
  'cust.form.creditLimitHint': 'Używany w uzgodnieniu do porównania otwartego salda klienta z własną polityką kredytową firmy. Limit nigdy nie blokuje fakturowania.',
  'cust.form.creditLimitPh': 'Np. 60000',
  'cust.form.note': 'Notatka o kliencie',
  'cust.form.notePh': 'Notatka o kliencie',
  'cust.form.activity': 'Dodaj notatkę o aktywności',
  'cust.form.activityPh': 'Zadzwoniono do klienta, wysłano aktualizację cen…',
  'cust.form.update': 'Aktualizuj klienta',
  'cust.form.save': 'Zapisz klienta',
  'cust.crm.prospect': 'Potencjalny klient',
  'cust.crm.quoteSent': 'Oferta wysłana',
  'cust.crm.active': 'Aktywny klient',
  'cust.crm.pause': 'Wstrzymany',
  'cust.chat.scope.all': 'Cała rozmowa',
  'cust.chat.scope.to': 'Do klienta',
  'cust.chat.scope.from': 'Od klienta',
  'cust.chat.scope.internal': 'Notatki wewnętrzne',
  'cust.chat.helpAll': 'Widzisz teraz całą rozmowę.',
  'cust.chat.helpTo': 'Widzisz teraz wysłane przez siebie wiadomości.',
  'cust.chat.helpFrom': 'Widzisz teraz wiadomości od klienta.',
  'cust.chat.helpInternal': 'To są Twoje wewnętrzne notatki w rozmowie.',
  'cust.chat.threadsHelpTitle': 'Rozmowy',
  'cust.chat.threadsHelp': 'Każdy klient może mieć kilka rozmów. Przełączaj się między nimi tutaj lub rozpocznij nową rozmowę dla nowego zapytania.',
  'cust.chat.conversation': 'Rozmowa',
  'cust.chat.filterTitle': 'Filtruj rozmowę',
  'cust.chat.filterHelp': 'Wybierz, co chcesz widzieć w oknie poniżej: całą rozmowę, wysłane wiadomości, wiadomości od klienta lub notatki wewnętrzne.',
  'cust.chat.windowTitle': 'Okno rozmowy',
  'cust.chat.windowHelp': 'Wiadomości w rozmowie. To, co wysyłasz, pojawia się po prawej, wiadomości klienta i notatki wewnętrzne po lewej. Przeciągnij dolną krawędź, aby powiększyć okno.',
  'cust.chat.internal': 'Wewnętrzne',
  'cust.chat.newInternalTitle': 'Nowa notatka wewnętrzna',
  'cust.chat.saveInDialog': 'Zapisz w rozmowie',
  'cust.chat.saveMessage': 'Zapisz wiadomość',
  'cust.chat.sendMessage': 'Wyślij wiadomość',
  'cust.chat.newTitle': 'Nowa wiadomość',
  'cust.chat.newHelp': 'Napisz odpowiedź do klienta, wklej otrzymaną wiadomość lub zanotuj coś wewnętrznie. Wybrany filtr rozmowy decyduje, czy treść zostanie wysłana do klienta, zapisana jako wiadomość klienta, czy jako notatka wewnętrzna.',
  'cust.chat.draftPh': 'Napisz odpowiedź, wklej wiadomość klienta lub zanotuj, co ustaliliście...',
  'cust.chat.newDialog': 'Nowa rozmowa',
  'cust.chat.quoteTitle': 'Podstawa oferty',
  'cust.chat.quoteHelp': 'Dodaj produkty i ceny uzgodnione w rozmowie. Naciśnij Utwórz ofertę, aby zamienić to w szkic oferty z już uzupełnionym klientem.',
  'cust.chat.findProduct': 'Znajdź produkt/cenę',
  'cust.chat.productPh': 'Szukaj nazwy produktu...',
  'cust.chat.dragToMessage': 'Przeciągnij do wiadomości',
  'cust.chat.dragTotal': 'Przeciągnij sumę do wiadomości',
  'cust.chat.dragBasis': 'Przeciągnij całą podstawę oferty do wiadomości',
  'cust.chat.quoteBasis': 'Cała podstawa',
  'cust.chat.remove': 'Usuń',
  'cust.chat.total': 'Suma',
  'cust.chat.makeQuote': 'Utwórz ofertę',
  'cust.toast.updated': 'Klient zaktualizowany',
  'cust.toast.saved': 'Klient zapisany',
  'cust.toast.saveFailed': 'Nie udało się zapisać klienta.',
  'cust.toast.archived': 'Klient przeniesiony do archiwum',
  'cust.toast.archiveFailed': 'Nie udało się zarchiwizować klienta.',
  'cust.toast.nothingToExport': 'Brak klientów do eksportu',
  'cust.toast.exportFailed': 'Nie udało się wyeksportować listy klientów.',
  'cust.toast.exported': 'Lista klientów pobrana',
  'cust.toast.noLedgerRows': 'Brak pozycji rozrachunków do eksportu',
  'cust.toast.ledgerExportFailed': 'Nie udało się wyeksportować rozrachunków z odbiorcami.',
  'cust.toast.ledgerExported': 'Rozrachunki z odbiorcami pobrane',
  'cust.toast.wrongFormat': 'Użyj pliku CSV lub XLSX z szablonem klientów Plumme.',
  'cust.toast.noneInFile': 'Nie znaleziono klientów w pliku.',
  'cust.toast.imported': 'Zaimportowani klienci: {n}',
  'cust.toast.importFailed': 'Nie udało się zaimportować klientów.',
  'cust.error.xlsxImport': 'Import XLSX nie jest jeszcze dostępny.',
  'cust.error.xlsxExport': 'Eksport do Excela nie jest jeszcze dostępny.',
  'cust.export.number': 'Nr klienta',
  'cust.export.name': 'Nazwa',
  'cust.export.org': 'Nr org.',
  'cust.export.email': 'E-mail',
  'cust.export.phone': 'Telefon',
  'cust.export.address': 'Adres',
  'cust.export.zip': 'Kod pocztowy',
  'cust.export.city': 'Miejscowość',
  'cust.export.status': 'Status',
  'cust.export.followUp': 'Następny kontakt',
  'cust.export.defaultRef': 'Stała referencja faktury',
  'cust.export.note': 'Notatka',
  'cust.ledger.code': 'Kod',
  'cust.ledger.date': 'Data',
  'cust.ledger.doc': 'Nr dowodu/faktury',
  'cust.ledger.type': 'Typ',
  'cust.ledger.due': 'Termin płatności',
  'cust.ledger.debit': 'Wn',
  'cust.ledger.credit': 'Ma',
  'cust.ledger.balance': 'Saldo po pozycji',
  'cust.ledger.paid': 'Zapłacono',
  'cust.ledger.remaining': 'Pozostało',
  'cust.ledger.partial': 'Częściowo zapłacono',
  'cust.ledger.unpaid': 'Niezapłacono',
  'cust.ledger.posted': 'Zaksięgowano',
  'cust.ledger.refund': 'Zwrot dla klienta',
  'cust.ledger.payment': 'Wpłata klienta',
  'cust.ledger.creditOverpayment': 'Kredyt / nadpłata',
  'cust.ledger.empty': 'Brak pozycji rozrachunków.',
  'cust.import': 'Importuj',
  'cust.importFrom': 'Importuj z',
  'cust.ledgerShort': 'Rozrachunki',
  'cust.ledger.sheet': 'Rozrachunki z odbiorcami',
  'cust.sheet.customers': 'Klienci',
});
